import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import Swal from "sweetalert2";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";
import TenantAPI from "../../api/TenantAPI";
import { FormBuilder } from "../../../types/FormBuilderInterfaces";

interface useCreatePublicFormInterface {
  form: FormBuilder;
  onSuccess?: (formID: string) => void;
}

const useCreatePublicForm = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const createPublicForm = useMutation({
    mutationFn: async ({ form }: useCreatePublicFormInterface) => {
      return TenantAPI.createPublicForm({ form });
    },
    onSuccess: (response, { onSuccess }) => {
      const newPublicForm = response.data.data.publicForm;

      queryClient.setQueryData(["publicForms", tenantID], (prev: any) => {
        if (!Array.isArray(prev)) return prev;

        return [...prev, newPublicForm];
      });

      newToastEvent(
        "success",
        `Successfully created public form "${newPublicForm.ModuleAPIName}".`
      );

      callFunctionIfExists(onSuccess, newPublicForm?.id);
    },
    onError: (err: any) => {
      Swal.fire({
        title: "Error",
        text: err.response.data.message,
        icon: "error",
      });
      newToastEvent("error", err.response.data.message);
    },
  });

  return {
    createPublicForm: createPublicForm.mutate,
    createPublicFormLoading: createPublicForm.isPending,
    createPublicFormError: createPublicForm.isError,
  };
};

export default useCreatePublicForm;
